import { render, staticRenderFns } from "./productcategorydetails.vue?vue&type=template&id=a194c060&scoped=true&"
import script from "./productcategorydetails.vue?vue&type=script&lang=js&"
export * from "./productcategorydetails.vue?vue&type=script&lang=js&"
import style0 from "./productcategorydetails.vue?vue&type=style&index=0&id=a194c060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a194c060",
  null
  
)

export default component.exports